import { ReactNode } from 'react'
import Styles from './RippleAnimation.module.scss'

interface Props {
  children: ReactNode
}

export const RippleAnimation = ({ children }: Props) => <div className={Styles.ripple}>{children}</div>
